import { AxiosInstance } from "axios";

export default class AiActiveCompaniesService {
  private axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async isAiActiveByManagerId(managerId: string): Promise<boolean> {
    const url = "/ai-active-companies/is-active";
    return this.axios.get(url, {
      params: { manager_id: managerId },
    });
  }
}
